import React, { useEffect, useState, useContext, useLayoutEffect } from "react";
import {
  GetPostMethodData,
  DecryptAESdata,
} from "../../../../provider/ServiceProvider";
import URLstateContext from "../../../../provider/CommonContext";
import "./DebtTable.css";
function DebtTable() {
  const { BaseURL } = useContext(URLstateContext);
  const [navrequest, setNavRequest] = useState("2");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    GetPostMethodData(BaseURL + "GetAumAndFoliocount", {
      IICategory: navrequest,
    }).then((responseData) => {
      if (responseData.data != null && responseData.data.length > 0) {
        setData(DecryptAESdata(responseData.data));
      }
    });
  }, [BaseURL]);

  const OvernightFund = ["JM Overnight Fund"];
  const LiquidFund = ["JM Liquid Fund"];
  const LowDurationFund = ["JM Ultra Short to Short Term Fund (Erstwhile known as JM Low Duration Fund)"];
  const ShortDurationFund = ["JM Short Term Fund (Erstwhile known as JM Short Duration Fund)"];
  const DynamicBondFund = ["JM Dynamic Term Fund (Erstwhile known as JM Dynamic Bond Fund)"];
  const MediumtoLongDurationFund = ["JM Medium to Long Term Fund (Erstwhile known as JM Medium to Long Duration Fund)"];

  return (
    <>
      {MediumtoLongDurationFund.map((FundName, index) => (
        <div key={index}>
          <>
            <table className="main-table">
              <thead>
                <tr>
                  <th className="column-heading">Features of the Scheme</th>
                  <th className="column-heading">{FundName}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="data-cell content">
                    Type of the <br />
                    Scheme
                  </td>
                  <td className="data-cell">
                    An open ended medium term debt scheme investing in
                    instruments such that the Macaulay duration of the portfolio
                    is between 4 years to 7 years. A relatively high interest
                    rate risk and moderate credit risk.
                  </td>
                </tr>
                <tr>
                  <td className="data-cell content">Category of the Scheme</td>
                  <td className="data-cell">Medium to Long Term Fund</td>
                </tr>
                <tr>
                  <td className="data-cell content">
                    Asset Allocation as per SID (in %)
                  </td>
                  <td className="data-cell">
                    <div>
                      <div className="random-heading">
                        Asset Allocation Pattern
                      </div>

                      <table className="inner-table">
                        <thead>
                          <tr>
                            <th rowspan="2">Types of Instruments</th>
                            <th colSpan="2">
                              Indicative Allocations (%) of Net Assets
                              <table className="sub-inner-table"></table>
                            </th>
                          </tr>
                          <tr>
                            <th>Minimum</th>
                            <th>Maximum</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Debt</td>
                            <td>0%</td>
                            <td>100%</td>
                          </tr>
                          <tr>
                            <td>
                              Money Market and Debt Instruments maturing within
                              one year
                            </td>
                            <td>0%</td>
                            <td>100%</td>
                          </tr>
                        </tbody>
                      </table>

                      <div>
                        The exposure in derivatives (fixed income) shall not exceed 50% of the net assets of the scheme.
                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className="random-text-cell content">
                    Investment Objective
                  </td>
                  <td className="random-text-cell">
                    To generate stable long term returns with low risk strategy
                    and capital appreciation/accretion through investment in
                    debt instruments and related securities besides preservation
                    of capital. Investors are required to read all the scheme
                    related information set out in this document carefully and
                    also note that there can be no assurance that the investment
                    objectives of the scheme will be realized. The schemes do
                    not guarantee/ indicate any returns.
                  </td>
                </tr>
                {data.map((fundData, index) => (
                  <React.Fragment key={index}>
                    {fundData.FundName === FundName && (
                      <>
                        <tr>
                          <td className="random-text-cell content">
                            Assets under Management
                          </td>
                          <td className="random-text-cell pos">
                            {fundData.MonthlyEndAum}
                          </td>
                        </tr>
                        <tr>
                          <td className="random-text-cell content">
                            No. of folios{" "}
                          </td>
                          <td className="random-text-cell pos">
                            {fundData.FolioCount}
                          </td>
                        </tr>
                      </>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
            <br />
            <br />
            <br />
          </>
        </div>
      ))}

      {DynamicBondFund.map((FundName, index) => (
        <div key={index}>
          <>
            <table className="main-table">
              <thead>
                <tr>
                  <th className="column-heading">Features of the Scheme</th>
                  <th className="column-heading">{FundName}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="data-cell content">
                    Type of the <br />
                    Scheme
                  </td>
                  <td className="data-cell">
                    An open ended dynamic debt scheme investing across duration.
                    A relatively high interest rate risk and moderate credit
                    risk.
                  </td>
                </tr>
                <tr>
                  <td className="data-cell content">Category of the Scheme</td>
                  <td className="data-cell">Dynamic Term Fund</td>
                </tr>
                <tr>
                  {/* <td className="data-cell content">Asset Allocation Pattern</td> */}
                  <td className="data-cell content">
                    Asset Allocation as per SID (in %)
                  </td>

                  <td className="data-cell">
                    <div>
                      <div className="random-heading">
                        Asset Allocation Pattern
                      </div>
                      {/* <ThirdTable/> */}
                      <table className="inner-table">
                        <thead>
                          <tr>
                            <th rowspan="2">Types of Instruments</th>
                            <th colSpan="2">
                              Indicative Allocations (%) of Net Assets
                              <table className="sub-inner-table"></table>
                            </th>
                          </tr>
                          <tr>
                            <th>Minimum</th>
                            <th>Maximum</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              Debt Instruments* including Government Securities
                              and Corporate Debt
                            </td>
                            <td>0%</td>
                            <td>100%</td>
                          </tr>

                          <tr>
                            <td>Money Market Instruments</td>
                            <td>0%</td>
                            <td>100%</td>
                          </tr>
                        </tbody>
                      </table>
                      <div>
                        *Exposure in securitized debt 0%-50% of net assets of
                        this scheme with low risk profile.
                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className="random-text-cell content">
                    Investment Objective
                  </td>
                  <td className="random-text-cell">
                    The investment objective will be to actively manage a
                    portfolio of good quality debt as well as Money Market
                    Instruments so as to provide reasonable returns and
                    liquidity to the Unit holders. Investors are required to
                    read all the Scheme related information set out in the offer
                    documents carefully and also note that there can be no
                    assurance that the investment objectives of the scheme will
                    be realized. The scheme does not guarantee/ indicate any
                    returns.
                  </td>
                </tr>
                {data.map((fundData, index) => (
                  <React.Fragment key={index}>
                    {fundData.FundName === FundName && (
                      <>
                        <tr>
                          <td className="random-text-cell content">
                            Assets under Management
                          </td>
                          <td className="random-text-cell pos">
                            {fundData.MonthlyEndAum}
                          </td>
                        </tr>
                        <tr>
                          <td className="random-text-cell content">
                            No. of folios{" "}
                          </td>
                          <td className="random-text-cell pos">
                            {fundData.FolioCount}
                          </td>
                        </tr>
                      </>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
            <br />
            <br />
            <br />
          </>
        </div>
      ))}

      {LiquidFund.map((FundName, index) => (
        <div key={index}>
          <>
            <table className="main-table">
              <thead>
                <tr>
                  <th className="column-heading">Features of the Scheme</th>
                  <th className="column-heading">{FundName}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="data-cell content">
                    Type of the <br />
                    Scheme
                  </td>
                  <td className="data-cell">
                    An Open-Ended Liquid Scheme. A relatively low interest rate
                    risk and moderate credit risk.
                  </td>
                </tr>
                <tr>
                  <td className="data-cell content">Category of the Scheme</td>
                  <td className="data-cell">Liquid Fund</td>
                </tr>
                <tr>
                  <td className="data-cell content">
                    Asset Allocation as per SID (in %)
                  </td>
                  <td className="data-cell">
                    <div>
                      <div className="random-heading">
                        Asset Allocation Pattern
                      </div>
                      {/* <ThirdTable/> */}
                      <table className="inner-table">
                        <thead>
                          <tr>
                            <th rowspan="2">Types of Instruments</th>
                            <th colSpan="2">
                              Indicative Allocations (%) of Net Assets
                              <table className="sub-inner-table"></table>
                            </th>
                          </tr>
                          <tr>
                            <th>Minimum</th>
                            <th>Maximum</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              Debt & Money Market Instruments with maturity up to 91 calendar days
                            </td>
                            <td>0%</td>
                            <td>100%</td>
                          </tr>
                        </tbody>
                      </table>
                      <div>
                        Exposure in securitized debt 0%-50% of net assets of
                        this scheme with low risk profile.
                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className="random-text-cell content">
                    Investment Objective
                  </td>
                  <td className="random-text-cell">
                    To provide income by way of dividend (dividend plans) and capital gains (growth plan) through investing in Debt and money market securities with maturity of upto 91 calendar days only. <br /> Investors are required to read all the scheme related information set out in this document carefully and also note that there can be no assurance that the investment objectives of the scheme will be realized. The scheme does not guarantee/ indicate any returns.
                  </td>
                </tr>
                {data.map((fundData, index) => (
                  <React.Fragment key={index}>
                    {fundData.FundName === FundName && (
                      <>
                        <tr>
                          <td className="random-text-cell content">
                            Assets under Management
                          </td>
                          <td className="random-text-cell pos">
                            {fundData.MonthlyEndAum}
                          </td>
                        </tr>
                        <tr>
                          <td className="random-text-cell content">
                            No. of folios{" "}
                          </td>
                          <td className="random-text-cell pos">
                            {fundData.FolioCount}
                          </td>
                        </tr>
                      </>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
            <br />
            <br />
            <br />
          </>
        </div>
      ))}

      {ShortDurationFund.map((FundName, index) => (
        <div key={index}>
          <>
            <table className="main-table">
              <thead>
                <tr>
                  <th className="column-heading">Features of the Scheme</th>
                  <th className="column-heading">{FundName}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="data-cell content">
                    Type of the <br />
                    Scheme
                  </td>
                  <td className="data-cell">
                    An open-ended short duration debt scheme investing in
                    instruments such that the Macaulay duration of the portfolio
                    is between 1 year to 3 years. A moderate interest rate risk
                    and moderate credit risk.
                  </td>
                </tr>
                <tr>
                  <td className="data-cell content">Category of the Scheme</td>
                  <td className="data-cell">Short Term Fund</td>
                </tr>
                <tr>
                  <td className="data-cell content">
                    Asset Allocation as per SID (in %)
                  </td>
                  <td className="data-cell">
                    <div>
                      <div className="random-heading">
                        Asset Allocation Pattern
                      </div>
                      {/* <ThirdTable/> */}
                      <table className="inner-table">
                        <thead>
                          <tr>
                            <th rowspan="2">Types of Instruments</th>
                            <th colSpan="2">
                              Indicative Allocations (%) of Net Assets
                              <table className="sub-inner-table"></table>
                            </th>
                          </tr>
                          <tr>
                            <th>Minimum</th>
                            <th>Maximum</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              Debt and Money market instruments such that the
Macaulay duration of the portfolio is between 1 year to 3 years (including securitised debt)*
                            </td>
                            <td>0%</td>
                            <td>100%</td>
                          </tr>
                        </tbody>
                      </table>
                      <div>
                        *The Scheme may invest in debt instruments with special features and will be made in accordance with Para-no 13.1.9 of SEBI Master Circular no. HO/24/13/11(1)2026-IMD-POD-1/I/7602/2026 dated March 20, 2026, as amended from time to time. In case of investments in debt securities with special features, the scheme will not invest more than 10% of its NAV of the debt portfolio in such instruments and not more than 5% of its NAV of the debt portfolio in such instruments issued by a single issuer.
                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className="random-text-cell content">
                    Investment Objective
                  </td>
                  <td className="random-text-cell">
                    The Scheme will endeavor to generate stable returns with a
                    low risk strategy while maintaining liquidity through a
                    portfolio comprising of debt and money market instruments.
                    Investors are required to read all the scheme related
                    information set out in the offer documents carefully and
                    also note that there can be no assurance that the investment
                    objectives of the scheme will be realized. The scheme does
                    not guarantee/ indicate any returns.
                  </td>
                </tr>
                {data.map((fundData, index) => (
                  <React.Fragment key={index}>
                    {fundData.FundName === FundName && (
                      <>
                        <tr>
                          <td className="random-text-cell content">
                            Assets under Management
                          </td>
                          <td className="random-text-cell pos">
                            {fundData.MonthlyEndAum}
                          </td>
                        </tr>
                        <tr>
                          <td className="random-text-cell content">
                            No. of folios{" "}
                          </td>
                          <td className="random-text-cell pos">
                            {fundData.FolioCount}
                          </td>
                        </tr>
                      </>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
            <br />
            <br />
            <br />
          </>
        </div>
      ))}

      {LowDurationFund.map((FundName, index) => (
        <div key={index}>
          <>
            <table className="main-table">
              <thead>
                <tr>
                  <th className="column-heading">Features of the Scheme</th>
                  <th className="column-heading">{FundName}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="data-cell content">
                    Type of the <br />
                    Scheme
                  </td>
                  <td className="data-cell">
                    An open ended ultra short to short term debt scheme investing in
instruments such that the Macaulay duration of the portfolio is between 6
months to 12 months. A relatively low interest rate risk and moderate credit
risk.
                  </td>
                </tr>
                <tr>
                  <td className="data-cell content">Category of the Scheme</td>
                  <td className="data-cell">Ultra Short to Short Term Fund</td>
                </tr>
                <tr>
                  <td className="data-cell content">
                    Asset Allocation as per SID (in %)
                  </td>
                  <td className="data-cell">
                    <div>
                      <div className="random-heading">
                        Asset Allocation Pattern
                      </div>
                      {/* <ThirdTable/> */}
                      <table className="inner-table">
                        <thead>
                          <tr>
                            <th rowspan="2">Types of Instruments</th>
                            <th colSpan="2">
                              Indicative Allocations (%) of Net Assets
                              <table className="sub-inner-table"></table>
                            </th>
                          </tr>
                          <tr>
                            <th>Minimum</th>
                            <th>Maximum</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Debt & Money Market
instruments such that the
Macaulay duration of the
portfolio is between 6 months
to 12 months
</td>
                            <td>0%</td>
                            <td>100%</td>
                            {/* <td>Low</td> */}
                          </tr>
                        </tbody>
                      </table>
                      {/* <div>
                        Exposure in securitized debt 0%-50% of net assets of
                        this scheme with low risk profile.
                      </div> */}
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className="random-text-cell content">
                    Investment Objective
                  </td>
                  <td className="random-text-cell">
                    To generate stable long term returns with low risk strategy
                    and capital appreciation/accretion besides preservation of
                    capital through investments in Debt & Money Market
                    instruments such that the Macaulay duration of the portfolio
                    is between 6 months - 12 months. Investors are required to
                    read all the scheme related information set out in the offer
                    document carefully and also note that there can be no
                    assurance that the investment objectives of the scheme will
                    be realized. The scheme does not guarantee/ indicate any
                    returns.
                  </td>
                </tr>
                {data.map((fundData, index) => (
                  <React.Fragment key={index}>
                    {fundData.FundName === FundName && (
                      <>
                        <tr>
                          <td className="random-text-cell content">
                            Assets under Management
                          </td>
                          <td className="random-text-cell pos">
                            {fundData.MonthlyEndAum}
                          </td>
                        </tr>
                        <tr>
                          <td className="random-text-cell content">
                            No. of folios{" "}
                          </td>
                          <td className="random-text-cell pos">
                            {fundData.FolioCount}
                          </td>
                        </tr>
                      </>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
            <br />
            <br />
            <br />
          </>
        </div>
      ))}

      {OvernightFund.map((FundName, index) => (
        <div key={index}>
          <>
            <table className="main-table">
              <thead>
                <tr>
                  <th className="column-heading">Features of the Scheme</th>
                  <th className="column-heading">{FundName}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="data-cell content">
                    Type of the <br />
                    Scheme
                  </td>
                  <td className="data-cell">
                    An open ended debt scheme investing in overnight securities.
                    A relatively low interest rate risk and relatively low
                    credit risk.
                  </td>
                </tr>
                <tr>
                  <td className="data-cell content">Category of the Scheme</td>
                  <td className="data-cell">Overnight Fund</td>
                </tr>
                <tr>
                  <td className="data-cell content">
                    Asset Allocation as per SID (in %)
                  </td>
                  <td className="data-cell">
                    <div>
                      <div className="random-heading">
                        Asset Allocation Pattern
                      </div>
                      {/* <ThirdTable/> */}
                      <table className="inner-table">
                        <thead>
                          <tr>
                            <th rowspan="2">Types of Instruments</th>
                            <th colSpan="2">
                              Indicative Allocations (%) of Net Assets
                              <table className="sub-inner-table"></table>
                            </th>
                          </tr>
                          <tr>
                            <th>Minimum</th>
                            <th>Maximum</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              Overnight securities or money market instruments* with maturity upto 1 business day
                            </td>
                            <td>0%</td>
                            <td>100%</td>
                          </tr>
                        </tbody>
                      </table>
                      <div>
                        The above limits shall be in line with the investment
                        objective of the Scheme. *instruments with residual
                        maturity not greater than 1 business day, including
                        money market instruments^, TREPS$ / reverse repo, debt
                        instruments^^, including floating rate instruments, with
                        overnight maturity.
                        <br />
                        ^ Commercial papers, commercial bills, treasury bills,
                        Government securities having an unexpired maturity upto
                        one year, call or notice money, certificate of deposit,
                        usance bill and any other like instruments as specified
                        by the Reserve Bank of India from time to time.
                        <br />
                        ^^Debt instruments would include all debt securities
                        issued by entities such as banks, companies, public
                        sector undertakings, municipal corporations, body
                        corporates, central government securities, state
                        development loans and UDAY bonds, recapitalization
                        bonds, municipal bonds and G-Sec repos and any other
                        instruments as permitted by regulators from time to
                        time.
                        <br />$ or similar instruments as may be permitted by
                        RBI/SEBI.
                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className="random-text-cell content">
                    Investment Objective
                  </td>
                  <td className="random-text-cell">
                    The Scheme aims to provide reasonable returns commensurate
                    with low risk and providing a high level of liquidity,
                    through investments made primarily in overnight securities
                    having maturity of 1 business day. Investors are required to
                    read all the scheme related information set out in this
                    document carefully and also note that there can be no
                    assurance that the investment objectives of the Scheme will
                    be realized. The Scheme do not guarantee/ indicate any
                    returns.
                  </td>
                </tr>
                {data.map((fundData, index) => (
                  <React.Fragment key={index}>
                    {fundData.FundName === FundName && (
                      <>
                        <tr>
                          <td className="random-text-cell content">
                            Assets under Management
                          </td>
                          <td className="random-text-cell pos">
                            {fundData.MonthlyEndAum}
                          </td>
                        </tr>
                        <tr>
                          <td className="random-text-cell content">
                            No. of folios{" "}
                          </td>
                          <td className="random-text-cell pos">
                            {fundData.FolioCount}
                          </td>
                        </tr>
                      </>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
            <br />
            <br />
            <br />
          </>
        </div>
      ))}
    </>
  );
}

export default DebtTable;

// testing comment
